
// Vue.component('example', require('./components/Example.vue'));
var $projects;

const site = new Vue({
    el: '#site',

    data: {
        bpTablet: 768,
        menuOpen: false,
        showContact: false,
        showDetails: true,
        showFilters: false,

        projects : {}
    },

    beforeMount() {
        document.querySelector('html').classList.remove('no-js');
    },

    mounted() {
        console.log('Site started');


        // Prevents links starting with # from moving page
        $('a[href^="#"]').click(function (e) {
            e.preventDefault();
        });

        this.updateHeaderSize();

        $(window)
            .scroll(_.debounce(() => {
                // Shrink header on scroll
                this.updateHeaderSize();
            }, 100));




        // Fades in featured projects on home page
        inView.offset(150);
        inView('.js-image').on('enter', el => el.classList.add('is-in-view'));


        // Sets first image to visible so it shows on larger screens
        $('.js-image:eq(0)').addClass('is-in-view');

        if ( window.innerWidth >= this.bpTablet ) {
            $('.js-image:eq(1)').addClass('is-in-view');
        }



        // Shows the Filters on the Work page
        $('.js-toggle-filters').click(() => {
            if ( !this.showFilters ) {
                this.showFilters = !this.showFilters;
            }
        });
    },


    methods: {
        /**
         * Open/Close the main menu
         */
        toggleMenu(action) {
            this.showContact = false;

            // if (action == 'open') {
            this.menuOpen = !this.menuOpen;

            if (this.menuOpen) {
                $('.js-hamburger').addClass('is-active');
                $('body').addClass('is-fixed');
            } else {
                $('.js-hamburger').removeClass('is-active');
                $('body').removeClass('is-fixed');
            }
        },



        /**
         * Shrinks the header when scrolling
         */
        updateHeaderSize() {
            // if ( $(window).scrollTop() > (window.innerHeight / 10)) {
            if ( $(window).scrollTop() > 50) {
                $('.c-header').addClass('is-shrunk');
            } else {
                $('.c-header').removeClass('is-shrunk');
            }
        },



        /**
         * Open/Close project details
         */
        toggleDetails() {
            this.showDetails = !this.showDetails;
            $('.js-details').slideToggle();
        },



        /**
         * Creates an isotope instance when the filters are opened
         */
        initIsotope() {
            // this.projects = $('.c-projects').isotope({
            //     itemSelector: ".c-project",
            //     layoutMode: "masonry",
            //     percentPosition: true
            // });
        },


        /**
         * Apply a filter to the projects via isotope
         */
        filterProjects(filter) {
            // this.projects.isotope({ filter: filter });
        }
    }
});



window.site = site;



// WEBPACK FOOTER //
// ./resources/assets/js/app.js